import { defineMessages } from 'react-intl';

/**
 * The admin suffix message used in document titles.
 */
const messages = defineMessages({
  admin: {
    id: 'main-layout.admin-nonfinal',
    description: 'General label for page titles.',
    defaultMessage: 'Atlassian Administration',
  },
});

export const adminMessage = messages.admin;
